import React from 'react';
import classNames from 'classnames';
import { dateFormat } from 'utils';
import { IconProp } from 'models/Icon';

import './ReportDetails.styles.scss';
import './ReportDetails.styles.responsive.scss';

type ReportDetailsProps = {
  className?: string;
  text: string;
  createdAt: Date;
  icon: IconProp;
};

const ReportDetails: React.FC<ReportDetailsProps> = (props) => {
  const { className, children, text, createdAt, icon: Icon } = props;

  const classes = classNames('report-details', className);

  return (
    <div className={classes}>
      <div className="report-details__main-info">
        <Icon />
        <p>{text}</p>
      </div>
      <div className="report-details__additional-info">
        <p>{dateFormat(createdAt, 'h:MMtt')}</p>
        <p>{dateFormat(createdAt, 'd/mm/yy')}</p>
        {children}
      </div>
    </div>
  );
};

export default ReportDetails;
